// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAtkyKq6_-6eztBYvbi_SrE_UiNbK6YTQI",
  authDomain: "creative-solutions-eee90.firebaseapp.com",
  projectId: "creative-solutions-eee90",
  storageBucket: "creative-solutions-eee90.appspot.com",
  messagingSenderId: "922115835347",
  appId: "1:922115835347:web:c77c7d1eebe9b1acb59b26",
  measurementId: "G-L0DWZJ5Z1P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };
